import { render, staticRenderFns } from "./SaldoMonedero.vue?vue&type=template&id=ebe7583e"
import script from "./SaldoMonedero.vue?vue&type=script&setup=true&lang=js"
export * from "./SaldoMonedero.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports